import InsuranceLookupImage from '@/assets/icons/insurance-lookup.svg';
import AddInsuranceManual from './steps/add-manual';
import AddInsuranceUpload from './steps/add-upload';
import { ROUTES } from '@/shared/constants/routes';

export type InsuranceFindTypes = 'LOOKUP' | 'MANUAL' | 'UPLOAD';

export const AUTO_LOOKUP_BLOCK = {
    type: 'LOOKUP',
    icon: <img width={124} src={InsuranceLookupImage} alt="insurance find" />,
    name: 'Use Our Insurance Finder',
    description:
        "We can streamline the process by allowing our system to automatically retrieve your insurance information using the details you've already provided.",
    buttonName: 'Look Up My Insurance'
};

export const INSURANCE_FIND_BLOCKS = [
    {
        type: 'UPLOAD',
        path: 'ADD_WITH_IMAGE',
        icon: (
            <i className="icon-camera mb-4 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-mint-400 text-2xl text-primary-800" />
        ),
        name: 'Add Insurance with Image',
        description: 'Upload a photo of your insurance card.',
        buttonName: 'Add Images'
    },
    {
        type: 'MANUAL',
        path: 'ADD_MANUAL',
        icon: (
            <i className="icon-pen mb-4 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-mint-400 text-2xl text-primary-800" />
        ),
        name: 'Add Insurance Manually',
        description: 'Type your insurance details yourself.',
        buttonName: 'Add Manually'
    }
];

export const INSURNACE_FIND_COMPONENT_MAP = {
    MANUAL: AddInsuranceManual,
    UPLOAD: AddInsuranceUpload
};

export interface IUnserviceableInsurance {
    name: string;
    resource: string;
    activation: string;
}

export const UNSERVICEABLE_INSURANCES: Record<string, IUnserviceableInsurance> = {
    // keeping for reference because this could be used in the future
    // humana: {
    //     name: 'humana',
    //     resource: 'activecampaign-webhook',
    //     activation: 'activation3'
    // },
};
